/**
 * @Author maogangfeng
 * @Date 2020-03-19 18:58:06
 * @Desc 预警管理常量
 */
export const STATUS_OVERTIE = '2'
export const STATUS_NOT_DEAL = '1'
export const STATUS_NOT_CHECK = '3'
export const STATUS_TYPE_NAME = {
  [STATUS_NOT_DEAL]: '待处置',
  [STATUS_OVERTIE]: '超期未处置',
  [STATUS_NOT_CHECK]: '待审核'
}
